import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Transfer money between two credit cards
@docs Não ha documentação
*/
export const creditTopupTransfer = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'cards/credit/topup/transfer',
		data: payload
	})
}

/** Get Topups Transfers List
@docs Não ha documentação
*/
export const getPaymentsList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'cards/topuptransfer/list',
		params: payload,
		isCancellable: true
	})
}

/** Get Credit Card Payments Methods List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardscreditpaymentMethod
*/
export const getCreditCardPaymentsMethodsList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'cards/credit/paymentMethod',
		params: payload,
		isCancellable: true
	})
}

/** Change Credit Card Payments Method
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_cardscreditpaymentMethod
*/
export const changeCreditCardPaymentsMethod = (payload) => {
	return httpClient({
		method: 'PUT',
		url: 'cards/credit/paymentMethod',
		data: payload,
		isCancellable: true,
		operationTypeId: 5024 /* for mocks handling of tokens */
	})
}

/** Charge Credit Card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cardscredit%7Bid%7Dtopup
*/
export const chargeCreditCard = (payload) => {
	return httpClient({
		method: 'POST',
		url: `cards/credit/${payload.cardId}/topup`,
        data: payload.data,
		isCancellable: true,
		operationTypeId: 500015 /* for mocks handling of tokens */
	})
}

/**
* payload
* @params { operationId: accountId, receiver: email that will receive the notification }
*/
export const sendFlexTransferEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/cards/credit/topup/transfer/${payload.operationId}/notification/email`,
		data: { email: payload.data.email }
	})
}

/**
* payload
* @params { operationId: id, receiver: phoneNumber that will receive the notification }
*/
export const sendFlexTransferSMSNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/cards/credit/topup/transfer/${payload.operationId}/notification/sms`,
		data: { phoneNumber: payload.data.phoneNumber }
	})
}

/** Creates the url to download credit card (flex) transfer receipt pdf
@docs Não há documentação
*/
export const createDownloadCreditTopUpTransfersPdf = operationId => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `cards/credit/topup/transfer/${operationId}/extract`
	})
}

/** Creates the url to download credit card charge receipt pdf
@docs Não há documentação
*/
export const createDownloadCreditTopUpChargePdf = operationId => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `cards/credit/${operationId}/extract`
	})
}
